import { render } from "./SettingsButton.vue?vue&type=template&id=62779d99"
import script from "./SettingsButton.vue?vue&type=script&lang=js"
export * from "./SettingsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__